module.exports = __webpack_public_path__ + "img/23.ef45a055.png";